import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

interface IProps {
	/**
	 * `light` paints the page area white and heads it like the rebuilt Coffee pages (Call log): a left-aligned title
	 * with the page's actions on the same row. `coffee` keeps the blue page and the centered display title.
	 */
	appearance?: 'coffee' | 'light';
	bodyStyles?: StyleDeclarationValue[];
	className?: string;
	/** Controls on the title row: right of the title on `light`, pinned right of the centered title on `coffee`. */
	headerActions?: React.ReactNode;
	headerStyles?: StyleDeclarationValue[];
	/** `light` only: overrides on the page box, e.g. a page that uses the full width instead of the centered column. */
	pageStyles?: StyleDeclarationValue[];
	title?: React.ReactNode;
}

export const BasicPage: React.FC<React.PropsWithChildren<IProps>> = ({
	appearance = 'coffee',
	children,
	bodyStyles = [],
	className = '',
	headerActions,
	headerStyles = [],
	pageStyles = [],
	title,
}) => {
	if (appearance === 'light') {
		return (
			<div className={css(styleSheet.lightBackdrop)}>
				<div className={`${css(styleSheet.lightPage, ...pageStyles)} ${className}`}>
					<div className={css(styleSheet.lightHeader, ...headerStyles)}>
						<h1 className={css(styleSheet.lightTitle)}>{title}</h1>
						{headerActions ? <div className={css(styleSheet.lightHeaderActions)}>{headerActions}</div> : null}
					</div>
					<div className={css(styleSheet.body, ...bodyStyles)}>{children}</div>
				</div>
			</div>
		);
	}
	return (
		<div className={`${css(styleSheet.basicPageContainer)} ${className}`}>
			<div className={css(styleSheet.header, ...headerStyles)}>
				<div className={css(styleSheet.title)}>{title}</div>
				{headerActions ? <div className={css(styleSheet.headerActions)}>{headerActions}</div> : null}
			</div>
			<div className={css(styleSheet.body, ...bodyStyles)}>{children}</div>
		</div>
	);
};
